module.exports = __webpack_public_path__ + "img/qr-bukutamu.bf443c20.png";